import React from 'react';
import SIcon from './SIcon';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faQuestionCircle} fa />;

export default Icon;
